import "../css/MoreServices.css";
import moreServices from "../data/moreServices";

const Group = ({ kicker, title, items }) => (
  <div className="msGroup">
    <span className="msKicker">{kicker}</span>
    <h2 className="msTitle">{title}</h2>
    <ul className="msGrid">
      {items.map((item) => (
        <li className="msTile" key={item}>
          <span className="msMark" aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const MoreServices = () => {
  return (
    <section className="moreServices">
      <div className="msInner">
        <Group
          kicker="Full Capabilities"
          title="More industrial moving services"
          items={moreServices.services}
        />
        <Group
          kicker="Specialized Experience"
          title="Equipment we handle"
          items={moreServices.equipment}
        />
      </div>
    </section>
  );
};

export default MoreServices;
